var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children, useEffect, useRef } from 'react';
import { useOnClickOutside, useOnEsc } from '../hooks';
import { withFlightUI } from '../withFlightUI';
import { DropdownMenuContext } from './DropdownMenu';
export const Items = (_a) => {
    var { onlyHide, closeOnClickOutside = true, children } = _a, rest = __rest(_a, ["onlyHide", "closeOnClickOutside", "children"]);
    const { setIsOpen, itemRefs, isOpen } = React.useContext(DropdownMenuContext);
    const ref = useRef();
    const close = () => isOpen && setIsOpen(false);
    useEffect(() => {
        if (!isOpen)
            return;
        if (itemRefs.current.length > 0) {
            itemRefs.current[0].current.focus();
            return;
        }
        ref.current.focus();
    }, [isOpen, itemRefs]);
    useOnClickOutside({
        condition: closeOnClickOutside,
        action: close,
        ref
    });
    useOnEsc({
        condition: isOpen,
        action: close
    });
    // TODO: full keyboard interactions specified @ https://www.w3.org/TR/wai-aria-practices-1.1/#menu
    const childrenWithIndex = Children.map(children, (child, index) => {
        return React.cloneElement(child, {
            index
        });
    });
    const El = withFlightUI(childrenWithIndex, Object.assign({ as: 'ul', role: 'menu', ref, tabIndex: -1, 'data-flight-dropdown-items': '' }, rest));
    // Return the element and rely on the CSS to hide
    if (onlyHide) {
        return El;
    }
    // Otherwise don't render anything when menu is closed
    return React.createElement(React.Fragment, null, isOpen ? El : null);
};
//# sourceMappingURL=Items.js.map